import type { PricingOption, PricingScope } from "@teamtable/content-sdk";

/** Wire shape from GET /api/v1/content/play-sessions/current. */
export interface ApiPricingOption {
  id: string;
  amount_pence: number;
  duration_minutes: number;
  currency: string;
  sort_order: number;
  badge?: string | null;
}

export function mapApiPricingOptions(rows: ApiPricingOption[]): PricingOption[] {
  return rows.map((r) => ({
    id: r.id,
    amountPence: r.amount_pence,
    durationMinutes: r.duration_minutes,
    currency: r.currency,
    sortOrder: r.sort_order,
    ...(r.badge ? { badge: r.badge } : {}),
  }));
}

/**
 * Stable fingerprint of the price book so BundleLoader can notify subscribePricing
 * only when something display-relevant changed (not on every identical poll).
 */
export function pricingBookFingerprint(
  options: PricingOption[],
  scope: PricingScope,
): string {
  const sorted = [...options].sort((a, b) => a.sortOrder - b.sortOrder || a.id.localeCompare(b.id));
  return JSON.stringify({
    scope,
    options: sorted.map((o) => ({
      id: o.id,
      amountPence: o.amountPence,
      durationMinutes: o.durationMinutes,
      currency: o.currency,
      sortOrder: o.sortOrder,
      badge: o.badge ?? null,
    })),
  });
}
